module.exports = __webpack_public_path__ + "img/singapore-featured-image-800x527.251df30e.jpg";